export const SUPPORTED_SYMBOLS_MODAL_CONSTANTS = {
  /** Content area height spacing multiplier (125 × 4px = 500px) */
  CONTENT_HEIGHT: 125,
  /** Search input max width spacing multiplier (63 × 4px = 252px) */
  SEARCH_MAX_WIDTH: 63,
  /** Search debounce in milliseconds */
  SEARCH_DEBOUNCE_MS: 300,
} as const;
